import { render, staticRenderFns } from "./TemplateemailHome.vue?vue&type=template&id=46620b48"
import script from "./TemplateemailHome.vue?vue&type=script&lang=js"
export * from "./TemplateemailHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports